// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3I3zQ","emails":"CreateEditClinics_emails__3REF-","emailTagLabel":"CreateEditClinics_emailTagLabel__1cjY_"};